// 規約本文は法的フルテキストのため、汎用 textarea の上限とは別に十分な文字数を許可する。
// InputTextArea の maxLength に渡すことで DOM 側の上限になり、Form の validate もこの値で判定する。
export const BODY_MAX_LENGTH = 50000

// 本文・差分が長い場合に初期表示する行数。これを超えたら「もっと見る」で全展開する
export const TEXT_INITIAL_LINE_COUNT = 20
